export default {
    'export': 'Export',
    'export-as-excel': 'Export as excel file',
    'print-journal-table': 'Print the journal',
    'search-within-caption': 'Find via description',
    'from-date': 'Start date',
    'to-date': 'End date',
    'only-debit-entries': 'Only debit entries',
    search: 'Search',
    cancel: 'Cancel',

    'sum-result-headers': {
        'sum-debits': 'Total debit',
        'sum-credits': 'Total credit',
        difference: 'Difference',
        'equivalent-currency': 'Equivalent currency',
        'currency-equivalent': 'Balance in another currency',
    },
    
    'sum-currencies-result-headers': {
        'currency-debits': 'Foreign currencies debit',
        'currency-credits': 'Foreign currencies credit',
    },
    
    headers: {
        'bond-no': 'Bond No.',
        sequence: 'Serial',
        account: 'Account',
        'account-no': 'Account ID',
        debit: 'Debit',
        credit: 'Credit',
        note: 'Description',
        currency: 'Currency',
        'currency-debit': 'Foreign currency debit',
        'currency-credit': 'Foreign currency credit',
        price: 'Price',
        'paper-document-no': 'Ref. Doc.',
        date: 'Date',
    },
    
    'details-depending-on-currencies' : 'Detailed total by other currencies',
}